<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <div class="row">
            <el-form-item label="Qrup" label-position="top">
                <policy-groups :id="$route.path.split('/')[3]" :disabled="this.editing" :isAllVisible="true"
                    @change-value="value => values.groupId = value" :propvalue="this.values.groupId"></policy-groups>
            </el-form-item>
            <el-form-item label="İstisna" label-position="top">
                <exceptions @change-value="value => values.exceptId = value" :propvalue="values.exceptId" :disabled="this.editing">
                </exceptions>
            </el-form-item>
            <el-form-item label="İstisna hallarının sayı" label-position="top">
                <el-input v-model="values.caseCount" type="Number" class="input-with-select w-60">
                    <template #append>
                        <el-select v-model="values.countLimitType" style="width: 150px" class="insured-search">
                            <el-option label="Şırkət üzrə" :value="1" />
                            <el-option label="Qrup üzrə" :value="2" />
                            <el-option label="Sığorta olunan üzrə" :value="3" />
                        </el-select>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="İstisna halları üzrə məbləğ" label-position="top">
                <el-input v-model="values.caseSum" type="Number" class="input-with-select w-60">
                    <template #append>
                        <el-select v-model="values.sumLimitType" style="width: 150px" class="insured-search">
                            <el-option label="Şırkət üzrə" :value="1" />
                            <el-option label="Qrup üzrə" :value="2" />
                            <el-option label="Sığorta olunan üzrə" :value="3" />
                            <el-option label="Göndəriş üzrə" :value="4" />
                        </el-select>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="Sayların istifadə qaydası" label-position="top">
                <el-select v-model="values.useType" style="width: 150px">
                    <el-option label="Bir dəfə" value="1" />
                    <el-option label="Hər dəfə" value="2" />
                </el-select>
            </el-form-item>
            <el-form-item label="Azadolma (%)" label-position="top">
                <el-input v-model="values.franchise" type="Number" class="w-30" />
            </el-form-item>
            <el-form-item label="Başlanma tarixi" prop="startDate" label-position="top">
                <el-date-picker format="DD.MM.YYYY" v-model="values.startDate" class="w-50" type="date" placeholder="Pick a day" />
            </el-form-item>
            <el-form-item label="Qeydlər" label-position="top">
                <el-input v-model="values.notes" />
            </el-form-item> 
        </div>

        <div class="row dialog-btn">
            <div>
                <soft-button @click="SubmitForm()" color="success">
                    {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                &nbsp;&nbsp;&nbsp;
                <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue"; 
import Exceptions from '@/project/Components/Exceptions.vue'; 

export default {
    components: {
        SoftButton,
        Exceptions 
    },
    props: {
        editing: Boolean,
        object: Object
    },
    data() {
        return {
            values: {},
            selected: null,
            rules: {
                startDate: [{ required: true, message: 'Mütləq sahə', trigger: 'change' }],
            }
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    //None
                }
            })
        }
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object }
        }
    },
}
</script>